import React, { useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import CustomFieldInput from "../Form/CustomFieldInput";
import "animate.css";

export default function SponsorshipForm(props) {
  const [sponsorship, setSponsorship] = useState(props.sponsorship);
  const [saving, setSaving] = useState(false);
  const [hide, setHide] = useState(false);

  const handleSubmit = () => {
    setSaving(true)

    HTTP.patch(`/sponsorships/${sponsorship.id}.json`, {
      sponsorship: sponsorship
    })
    .then(response => {
      props.updateSponsorship(response.data);
      setTimeout(() => { 
        setSaving(false); 
        Alert.show("notice", "Sponsorship saved!");
        handleClose();
      }, 1000);
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
      setSaving(false);
    })
  }

  const updateSponsorshipCustomField = (updatedCustomField) => {
    let customFields = sponsorship.custom_fields.map((custom_field, idx) => {
      if(custom_field.team_custom_field_id === updatedCustomField.team_custom_field_id) {
        return updatedCustomField
      } else {
        return custom_field;
      }
    });

    setSponsorship(sponsorship => {
      return { ...sponsorship, custom_fields: customFields }
    });
  }

  const handleClose = () => {
    setHide(true);
    setTimeout(() => {
      props.setOpenCustomFieldsForm(false)
    },500)
  }

  return (
    <React.Fragment>
      {props.openCustomFieldsForm && (<div>
        <div onClick={handleClose} className="card-modal--overlay"></div>
        <div className={`card card-modal 
          animate__animated
          animate__fadeInUp
          animate__faster
          ${hide ? "animate__fadeOutDown" : ""}
        `}>
          <div className="card-header flex-header">
            <h4 className="card-title">
              Sponsorship
            </h4>
            
            <div>
              <button onClick={handleClose} className="btn btn-outline-danger mr-1">
                Cancel
              </button>

              <button onClick={handleSubmit} name="button" className="btn btn-primary">
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                Save
              </button>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                {sponsorship.custom_fields.map((custom_field) => 
                  <CustomFieldInput 
                    key={custom_field.team_custom_field_id}
                    customField={custom_field} 
                    updateSponsorshipCustomField={updateSponsorshipCustomField} 
                  /> 
                )}
              </div>
            </div>  
          </div>
        </div>
      </div>)}
    </React.Fragment>
  );
}

SponsorshipForm.propTypes = {
  sponsorship: PropTypes.object
};
